export const LoadingSpinner = ({ text }) => (
	<div className="min-h-screen bg-gray-50 flex items-center justify-center">
		<div className="flex flex-col items-center gap-4">
			<div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
			<p className="text-gray-600">{text}</p>
		</div>
	</div>
);
